import { RegionType } from '@wix/shoutout-email-model-v3';
import { defaultLineHeight, defaultTextColor, defaultTextSize, } from '../../utils/defaults';
import { getTextAlign } from '../../utils/get-text-align';
import { injectMissingPropsIntoHtml } from '../../utils/inject-missing-props-into-html';
import { wrapWithElement } from '../../utils/wrap-with-element';
export var getText = function (_a) {
    var region = _a.region, css = _a.css, composerData = _a.composerData, experiments = _a.experiments, isRtl = _a.isRtl, manipulateHtml = _a.manipulateHtml;
    if (region.type !== RegionType.Text) {
        throw Error('Text must be passed');
    }
    var cssClass = 'so-global-p1';
    var textStyle = css[cssClass];
    var globalStyle = css['so-global-text-mix'];
    var textAlign = getTextAlign(globalStyle.textAlign, isRtl ? 'right' : 'left');
    var props = {
        lineHeight: textStyle.originalLineHeight || defaultLineHeight,
        fontSize: textStyle.fontSize || defaultTextSize,
    };
    var processedHtml = manipulateHtml
        ? injectMissingPropsIntoHtml(wrapWithElement(region.data.html, 'div', cssClass), props, composerData, css, experiments, true)
        : wrapWithElement(region.data.html, 'div', cssClass);
    // TODO: here we should also return fontSize and fontStyle.
    // fontSize: textStyle.fontSize || globalStyle.fontSize
    return {
        align: textAlign,
        color: textStyle.color || defaultTextColor,
        fontFamily: textStyle.fontFamily,
        html: processedHtml,
        regionId: region.regionId,
        textTransform: textStyle.textTransform || 'none',
        type: 'text',
    };
};
//# sourceMappingURL=get-text.js.map